module.exports = __webpack_public_path__ + "static/media/scanProductRefive.5e5a0322.png";